<h4 class="mb-5">{{ addEdit }} folder</h4>

<div>
	<p class="bg-gray-100 p-3 mb-3 shadow">
		/ Templates<ng-container *ngFor="let folder of breadcrumbs">
			/ <span [innerHtml]="folder.title"></span
		></ng-container>
		/
	</p>
	<div>
		<app-input
			class="max-w-350 mb-4"
			label="Folder name"
			[(ngModel)]="folder.title"
			placeholder="Folder name"
		></app-input>
	</div>
	<div>
		<label class="font-bold text-base">Document available in</label>
		<matter-type-selector
			*ngIf="folder"
			[(matterTypes)]="folder.matterType"
			[showMatterTypes]="data.showMatterTypes"
		></matter-type-selector>
		<matter-type-selector
			*ngIf="!folder"
			[(matterTypes)]="data.matterFileTypes"
			[showMatterTypes]="data.showMatterTypes"
		></matter-type-selector>
	</div>
</div>

<div class="flex justify-between mt-10">
	<app-button btn="tertiary" class="mr-5" (click)="cancelModal()" size="small"
		>Cancel</app-button
	>
	<app-button size="small" (click)="saveFolder()">{{
		addEdit === 'Add' ? 'Create' : 'Save'
	}}</app-button>
</div>
